document.addEventListener('DOMContentLoaded', function () {
  const personalizarRadio = document.querySelector('input[value="Com Personalização (R$20)"]');
  const naoPersonalizarRadio = document.querySelector('input[value="Sem Personalização"]');

  // Cria o bloco estilizado de inputs
  const campoPersonalizacao = document.createElement('div');
  campoPersonalizacao.id = 'campos-personalizar';
  campoPersonalizacao.style.display = 'none'; // escondido inicialmente

  campoPersonalizacao.innerHTML = `
    <div class="personalizar-box">
      <div class="personalizar-group">
        <label class="personalizar-label" for="nome-camisa">
          <strong>NOME</strong> <span>(ATÉ 15 CARACTERES)</span>
        </label>
        <input type="text" maxlength="15" name="properties[Nome]" id="nome-camisa" placeholder="Ex: João da Silva"  />
      </div>
      <div class="personalizar-group">
        <label class="personalizar-label" for="numero-camisa">
          <strong>NÚMERO</strong> <span>(MÁXIMO 3 CARACTERES)</span>
        </label>
        <input type="text" maxlength="3" name="properties[Número]" id="numero-camisa" placeholder="Ex: 10" />
      </div>
    </div>
  `;

  // Adiciona dentro do form, antes do botão "Adicionar ao carrinho"
  const variantesDiv = document.querySelector('product-variants.product-form__variants');
  variantesDiv.append(campoPersonalizacao);

  // Lógica de exibição
  function toggleCampos() {
    if (personalizarRadio && personalizarRadio.checked) {
      campoPersonalizacao.style.display = 'block';
    } else {
      campoPersonalizacao.style.display = 'none';
    }
  }

  personalizarRadio?.addEventListener('change', toggleCampos);
  naoPersonalizarRadio?.addEventListener('change', toggleCampos);

  toggleCampos(); // Inicializa corretamente no carregamento
});
